import { CardHeader } from '../../../card/app';
import { IBaseChartProps } from '../base-chart/interface';
import { RenderLastValue } from '../render-last-value';

export const withContainer =
  (Component: React.FC<any>) =>
  ({
    title,
    subTitle,
    tooltipText,
    className,
    cardFooter,
    ...props
  }: IBaseChartProps & { id?: string; headerActions?: React.ReactNode }) => {
    const headerActions =
      props.renderLastValue && props.series ? (
        <RenderLastValue
          series={props.series}
          renderLastValue={props.renderLastValue}
        />
      ) : (
        props?.headerActions
      );

    return (
      <CardHeader
        title={title}
        subTitle={subTitle}
        tooltipText={tooltipText}
        id={`container-${props?.id}`}
        headerActions={headerActions}
        cardFooter={cardFooter}
        className={className}
      >
        <Component {...props} />
      </CardHeader>
    );
  };
